import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    placements: {
      selectIds: [],
      filters: {},
      selectId: false
    }
  },
  mutations: {
    SET_PLACEMENT_SELECT_IDS (store, ids) {
      store.placements.selectIds = ids
    },
    REMOVE_PLACEMENT_SELECT_IDS (store, ids) {
      store.placements.selectIds = store.placements.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_PLACEMENT_SELECT_ID (store, id) {
      store.placements.selectId = id
    },
    SET_PLACEMENT_FILTERS (store, filters) {
      store.placements.filters = filters
    }
  },
  getters: {
    getPlacements: (store, getters) => {
      return store.placements.selectIds.map((id) => {
        return getters['entities/placements/find'](id)
      })
    },
    getPlacementsFilters: (store, getters) => {
      return store.placements.filters
    },
    getPlacement: (store, getters) => {
      return getters['entities/placements/find'](store.placements.selectId) || {}
    }
  },
  actions: {
    /*
    selectPlacements
    */
    selectPlacements ({commit, dispatch, getters, state}, filters) {
      return dispatch('getPlacements', filters)
      .then((response) => {
        commit('SET_PLACEMENT_FILTERS', filters)
        commit('SET_PLACEMENT_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectPlacements
    */
    refreshSelectPlacements ({commit, dispatch, getters, state}) {
      return dispatch('selectPlacements', getters.getPlacementsFilters)
    },
    /*
    selectPlacement
    */
    selectPlacement ({commit, dispatch, getters, state}, id) {
      return dispatch('getPlacementById', id)
      .then((response) => {
        commit('SET_PLACEMENT_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getPlacements
    */
    getPlacements ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/placements`, {params: filters})
      .then((response) => {
        return dispatch('entities/placements/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.placements || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getPlacementById
    */
    getPlacementById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/placements/${id}`)
      .then((response) => {
        return dispatch('entities/placements/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.placements[0]
      })
    },
    /*
    createPlacement
    */
    createPlacement ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/placements`, data)
      .then((response) => {
        return dispatch('entities/placements/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('changePlacement', response.placements[0])
        return response.placements[0]
      })
    },
    /*
    updatePlacement
    */
    updatePlacement ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/placements/${data._id}`, data)

      .then((response) => {
        return dispatch('entities/placements/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('changePlacement', response.placements[0])
        return response.placements[0]
      })
    },
    /*
    disqualifyPlacement
    */
    disqualifyPlacement ({commit, dispatch, getters, state}, data) {
      return axios
      .put(`/accounts/${getters.getAccount._id}/placements/${data._id}/disqualify`, data)
      .then((response) => {
        return dispatch('entities/placements/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('changePlacement', response.placements[0])
        return response.placements[0]
      })
    },
    /*
    requalifyPlacement
    */
    requalifyPlacement ({commit, dispatch, getters, state}, data) {
      return axios
      .put(`/accounts/${getters.getAccount._id}/placements/${data._id}/requalify`, {}) // disqualify_reason_id: null
      .then((response) => {
        return dispatch('entities/placements/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('changePlacement', response.placements[0])
        return response.placements[0]
      })
    },
    /*
    movePlacement
    */
    movePlacement ({commit, dispatch, getters, state}, data) {
      return axios
      .put(`/accounts/${getters.getAccount._id}/placements/${data._id}/move`, data)
      .then((response) => {
        return dispatch('entities/placements/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('changePlacement', response.placements[0])
        return response.placements[0]
      })
    },
    /*
    deletePlacement
    */
    deletePlacement ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/placements/${id}`)
      .then((response) => {
        commit('REMOVE_PLACEMENT_SELECT_IDS', [id])
        dispatch('entities/placements/delete', id)
        dispatch('changePlacement', {})
        return {}
      })
    },
    /*
    changePlacement
    */
    changePlacement ({commit, dispatch, getters, state}, data) {
      dispatch('getCandidateById', data.candidate_id)
      dispatch('getJobById', data.job_id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Placement.js